import { useAuth } from "@/App";
import { AlertTriangle } from "lucide-react";

export default function PayPalEmailWarning() {
  const { user } = useAuth();
  if (!user?.email) return null;

  return (
    <div
      className="flex items-start gap-2 p-3 rounded-lg bg-amber-500/10 border border-amber-500/30 text-left"
      data-testid="paypal-email-warning"
    >
      <AlertTriangle className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
      <p className="text-xs text-amber-200/90 leading-relaxed">
        <strong>Important:</strong> pay with the PayPal account registered to{" "}
        <span className="font-semibold text-amber-100 select-all">{user.email}</span>.
        Purchases made from a different PayPal email can't be matched to your LuxeMeet
        account and the funds won't apply automatically.
      </p>
    </div>
  );
}
